<!-- Pills Section -->
<div class="Notification-pills u-spacing-lg-mb">
    <div class="flex Notification-pills--truncate">
        <ce-pill state="default" ce-pill-xs ce-pill-secondary class="u-spacing-sm-mr">
            {{ stationName() }}
        </ce-pill>
    </div>
    <div class="flex flex-end">
        @if (notification().archived) {
            <ce-pill [state]="'default'" icon="archive" ce-pill-xs ce-pill-secondary class="u-spacing-sm-mr">Archived</ce-pill>
        }
        @if (notification().eventState === 'active') {
            <ce-pill [state]="'info'" ce-pill-xs ce-pill-secondary>Active</ce-pill>
        } @else {
            <span class="u-text-body-xs u-color-text-secondary">Resolved</span>
        }
    </div>
</div>

<!-- Summary Text -->
<p class="Notification-summary u-text-body-lg">{{ pmcNotificationMessage() }}</p>
@if (severityMessage()) {
    <p class="Notification-summary u-text-body-lg u-spacing-md-mt">{{ severityMessage() }}</p>
}

<!-- Action Button -->
<a
    [href]="detailsInClassicUrl()"
    target="_blank"
    [ceTooltip]="tooltipText()"
    ce-button
    ce-button-small
    ce-button-type-tertiary
    class="u-spacing-xl-mt u-spacing-2xl-mb"
>
    {{ linkLabel() }}
    <ce-icon [svgIcon]="'new-tab'" ce-icon-xs suffix-icon />
</a>

<!-- Parameter List -->
<ce-parameter-list size="small">
    <ce-parameter-item [orientation]="'horizontal'">
        <span ceParameterLabel>
            @if (hasMultipleEvents()) { First event occurred } @else { Event occurred }
        </span>
        <span ceParameterItemValue class="u-text-align-right">{{ notification().eventTimestamp }}</span>
    </ce-parameter-item>
    <ce-parameter-item [orientation]="'horizontal'">
        <span ceParameterLabel>Notification sent</span>
        <span ceParameterItemValue class="u-text-align-right">{{ notification().notificationTimestamp }}</span>
    </ce-parameter-item>
    <ce-parameter-item [orientation]="'horizontal'">
        <span ceParameterLabel>Event resolved</span>
        @if (notification().eventResolvedTimestamp) {
            <span ceParameterItemValue class="u-text-align-right">{{ notification().eventResolvedTimestamp }}</span>
        } @else {
            <span ceParameterItemValue class="u-text-placeholder u-text-align-right">Not yet resolved</span>
        }
    </ce-parameter-item>
    @if (notification().eventState !== 'active') {
        <ce-parameter-item [orientation]="'horizontal'">
            <span ceParameterLabel>Resolution reason</span>
            <span ceParameterItemValue class="u-text-align-right">Errors no longer active</span>
        </ce-parameter-item>
    }
    <ce-parameter-item [orientation]="'horizontal'">
        <span ceParameterLabel>Site</span>
        <span ceParameterItemValue class="u-text-align-right">{{ locationName() || notification().siteName }}</span>
    </ce-parameter-item>
    <ce-parameter-item [orientation]="'horizontal'">
        <span ceParameterLabel>Charging station</span>
        <span ceParameterItemValue class="u-text-align-right">{{ stationName() }}</span>
    </ce-parameter-item>
    <ce-parameter-item [orientation]="'horizontal'">
        <span ceParameterLabel>Firmware version</span>
        <span ceParameterItemValue class="u-text-align-right">{{ firmwareVersion() }}</span>
    </ce-parameter-item>
    <ce-parameter-item [orientation]="'horizontal'">
        <span ceParameterLabel>Serial number</span>
        <span ceParameterItemValue class="u-text-align-right">{{ serialNumber() }}</span>
    </ce-parameter-item>
    <ce-parameter-item [orientation]="'horizontal'">
        <span ceParameterLabel>Product code</span>
        <span ceParameterItemValue class="u-text-align-right">{{ stationModel() }}</span>
    </ce-parameter-item>
    <ce-parameter-item [orientation]="'horizontal'">
        <span ceParameterLabel>Charging station owner</span>
        <span ceParameterItemValue class="u-text-align-right">{{ ownerOrganizationName() }}</span>
    </ce-parameter-item>
    <ce-parameter-item [orientation]="'horizontal'">
        <span ceParameterLabel>Email notification</span>
        <span ceParameterItemValue class="u-text-align-right">
            @if (emailTimestamp()?.timestamp) { Sent } @else { Not sent }
        </span>
    </ce-parameter-item>
</ce-parameter-list>

<!-- Module Error Sections -->
@if (moduleErrorSections().length > 0) {
    @for (section of moduleErrorSections(); track $index) {
        <div class="NotificationPmCFault u-spacing-2xl-mt">
            <h2 class="u-text-title-xs u-spacing-sm-mb">{{ section.title }}</h2>
            @for (error of section.errors; track $index) {
                <div class="u-spacing-md-mt">
                    <ce-parameter-list size="small">
                        <ce-parameter-item [orientation]="'horizontal'" [truncated]="true">
                            <span ceParameterLabel>Error code</span>
                            <span ceParameterItemValue>{{ error.code }}</span>
                        </ce-parameter-item>
                        <ce-parameter-item [orientation]="'horizontal'">
                            <span ceParameterLabel>Severity</span>
                            <span ceParameterItemValue>
                                <ce-pill [state]="error.severityPillState" [icon]="error.severityIcon" ce-pill-xs ce-pill-tertiary class="u-text-truncate">
                                    {{ error.description }}
                                </ce-pill>
                            </span>
                        </ce-parameter-item>
                    </ce-parameter-list>
                </div>
            }
        </div>
    }
}

<!-- Per-station details for multiple events -->
@if (hasMultipleEvents()) {
    @for (event of formattedEvents(); let i = $index; track i) {
        <div class="u-spacing-2xl-mt">
            <h2 class="u-text-title-xs u-spacing-sm-mb">
                {{ event.metadata?.['stationName'] ?? event.metadata?.['stationId'] }}
            </h2>
            <ce-parameter-list size="small">
                <ce-parameter-item [orientation]="'horizontal'">
                    <span ceParameterLabel>Event occurred</span>
                    <span ceParameterItemValue class="u-text-align-right">
                        {{ event.formattedTimestamp }}
                    </span>
                </ce-parameter-item>
                <ce-parameter-item [orientation]="'horizontal'">
                    <span ceParameterLabel>Message</span>
                    <span ceParameterItemValue class="u-text-align-right">
                        {{ event.metadata?.['message'] }}
                    </span>
                </ce-parameter-item>
            </ce-parameter-list>
        </div>
    }
}
